export default __webpack_public_path__ + "static/media/dashboard_icon.bcc809ac.svg";